import { registerExtension } from "@core/components/PipelineComponents/ExtensionProvider";
import { CategoryMenu } from "@/overrides/ecommerce/components/CategoryMenu";

/**
 * Override the plugin's MegaMenu-based "Products" tab (registered at
 * "HomepageTabs.before") with the SPG-styled CategoryMenu nav-dropdown.
 *
 * Passing isOverride=true causes registerExtension to replace the existing
 * "ProductTab" registration rather than throwing a duplicate-name error.
 */
registerExtension("HomepageTabs.before", CategoryMenu, "ProductTab", true);
